import { API, Form, FormAPI, Group, GroupAPI, Team, TeamAPI } from '@brg/api';
import { useAssociatedProfile } from '@brg/auth';
import { useCallback, useEffect, useState } from 'react';
import urlApi from 'shared/actions/urlApi';
import { computeGroup } from 'shared/helpers/types/computed/ComputedGroup';
import { ComputedTeam, computeTeam } from 'shared/helpers/types/computed/ComputedTeam';
import { AppTester } from 'supporting';

export const useTeam = (id: string , date: number, lang: string, disable?: boolean) => {
    const [data, setData] = useState<ComputedTeam>();

    const fetchGroup = (id: string) => {
        TeamAPI.Get({ idTeam: id })
        .then((r: any) => r.json())
        .then((r) => !!r && setData(API.toLang(computeTeam(r), lang)))
    } 

    useEffect(() => {
        if (!!id?.length && !disable) {
            fetchGroup(id)
        } 
    } , [id, date, lang, disable])

    return data;
}import { API, Form, FormAPI, Group, GroupAPI, Team, TeamAPI } from '@brg/api';
import { useAssociatedProfile } from '@brg/auth';
import { useCallback, useEffect, useState } from 'react';
import urlApi from 'shared/actions/urlApi';
import { computeGroup } from 'shared/helpers/types/computed/ComputedGroup';
import { ComputedTeam, computeTeam } from 'shared/helpers/types/computed/ComputedTeam';
import { AppTester } from 'supporting';

export const useTeam = (id: string , date: number, lang: string, disable?: boolean) => {
    const [data, setData] = useState<ComputedTeam>();

    const fetchGroup = (id: string) => {
        TeamAPI.Get({ idTeam: id })
        .then((r: any) => r.json())
        .then((r) => !!r && setData(API.toLang(computeTeam(r), lang)))
    } 

    useEffect(() => {
        if (!!id?.length && !disable) {
            fetchGroup(id)
        } 
    } , [id, date, lang, disable])

    return data;
}